module.exports = __webpack_public_path__ + "static/media/human6.f6f63732.jpg";